module.exports = __webpack_public_path__ + "static/media/timer.1244aeb7.png";